module.exports = __webpack_public_path__ + "static/img/index.c948646.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/index.png
// module id = zICw
// module chunks = 1